// extracted by mini-css-extract-plugin
module.exports = {"figure":"bh_gz","figure_isMargin":"bh_g0","figure__link":"bh_g1","figure__caption":"bh_g2"};